export function capitalize (string: string): string {
  const head = string.charAt(0)
  const tail = string.slice(1)

  return head.toLocaleUpperCase() + tail
}

export function camelCase (stringToCamelCase: string): string {
  const noSpecialCharacters = stringToCamelCase.replace(/[^a-zA-Z0-9 ]/g, '')

  const words = noSpecialCharacters.split(' ')

  const wordsToJoin = []
  const firstWord = words[0].toLocaleLowerCase()

  wordsToJoin.push(firstWord)

  for (let index = 1; index < words.length; index++) {
    wordsToJoin.push(capitalize(words[index].toLocaleLowerCase()))
  }

  return wordsToJoin.join('')
}
